import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCampaign from './campaign.reducer';

import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';

export const selectCampaignState = createFeatureSelector<fromCampaign.State>(
  fromCampaign.campaignFeatureKey
);

export const selectCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.DONATE:
        case CAMPAIGN_TYPE.MERCHANDISE:
        case CAMPAIGN_TYPE.HINDU_TEMPLE_PUJA:
        case CAMPAIGN_TYPE.AUCTION:
        case CAMPAIGN_TYPE.TICKETING:
        case CAMPAIGN_TYPE.LONG_PLEDGE:
        case CAMPAIGN_TYPE.PEER_TO_PEER:
        case CAMPAIGN_TYPE.LAST_HERO:
        case CAMPAIGN_TYPE.PARTY_SIGNUP:
        case CAMPAIGN_TYPE.IN_KIND:
          return true;
      }
      return false;
    });
  }
);

export const selectDonationCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.DONATE:
          return true;
      }
      return false;
    });
  }
);

export const selectTicketingCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.TICKETING:
          return true;
      }
      return false;
    });
  }
);

export const selectMerchandiseCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.MERCHANDISE:
          return true;
      }
      return false;
    });
  }
);

export const selectPartySignUpCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.PARTY_SIGNUP:
          return true;
      }
      return false;
    });
  }
);

export const selectInKindCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.IN_KIND:
          return true;
      }
      return false;
    });
  }
);

export const selectEventPageCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.DONATE:
        case CAMPAIGN_TYPE.TICKETING:
        case CAMPAIGN_TYPE.LONG_PLEDGE:
        case CAMPAIGN_TYPE.PEER_TO_PEER:
        case CAMPAIGN_TYPE.MERCHANDISE:
        case CAMPAIGN_TYPE.PARTY_SIGNUP:
        case CAMPAIGN_TYPE.HINDU_TEMPLE_PUJA:
        case CAMPAIGN_TYPE.IN_KIND:
          return true;
      }
      return false;
    });
  }
);

export const selectSilentAuctionCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.AUCTION:
          return entity.campaignTypeData.auctionType === 0;
      }
      return false;
    });
  }
);

export const selectLiveAuctionCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.AUCTION:
          return entity.campaignTypeData.auctionType === 1;
      }
      return false;
    });
  }
);

export const selectAuctionCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.AUCTION:
        return true;
      }
      return false;
    });
  }
);


export const selectPeerToPeerCampaignList = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    const entities = _.map(state.entities, entity => entity);
    return _.filter(entities, entity => {
      switch(entity.type) {
        case CAMPAIGN_TYPE.PEER_TO_PEER:
        return true;
      }
      return false;
    });
  }
);

export const selectHinduTempleLocations = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    return state.hinduTempleLocations;
  }
);

export const selectNotArchivedCampaignList = createSelector(
  selectCampaignList,
  (entities) => {
    return _.filter(entities, entity => entity.status < 5)
  }
);

export const selectActiveCampaignList = createSelector(
  selectCampaignList,
  (entities) => {
    return _.filter(entities, entity => _.isEqual(entity.status, 0))
  }
);

export const selectCampaignSelected = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => {
    if(_.isNull(state.selectedCampaign)) {
      return null;
    }

    return state.selectedCampaign;
  }
);

export const selectCampaignOptionSelected = createSelector(
  selectCampaignState,
  (state: fromCampaign.State) => state.selectedOption
);

export const selectTicketComboName = (campaignId, optionId, count) => {
  return createSelector(
    selectTicketingCampaignList,
    (entities) => {
      const campaign = _.find(entities, entity => {
        return entity.id === campaignId
      }) || {
        name: "Unknown Campaign",
        campaignTypeData: {
          presetOptions: []
        }
      };
      const option = _.find(campaign.campaignTypeData.presetOptions, presetOption => {
        return presetOption.id === optionId
      }) || {
        name: "Unknown Preset Option",
        multiplier: 0
      };
      return `${option.name}`;
    }
  )
}

export const selectTicketComboCampaignName = (campaignId, optionId, count) => {
  return createSelector(
    selectTicketingCampaignList,
    (entities) => {
      const campaign = _.find(entities, entity => {
        return entity.id === campaignId
      }) || {
        name: "Unknown Campaign",
        campaignTypeData: {
          presetOptions: []
        }
      };
      const option = _.find(campaign.campaignTypeData.presetOptions, presetOption => {
        return presetOption.id === optionId
      }) || {
        name: "Unknown Preset Option",
        multiplier: 0
      };
      return `${campaign.name}`;
    }
  )
}

export const selectTicketComboQuantity = (campaignId, optionId, count) => {
  return createSelector(
    selectTicketingCampaignList,
    (entities) => {
      const campaign = _.find(entities, entity => {
        return entity.id === campaignId
      }) || {
        name: "Unknown Campaign",
        campaignTypeData: {
          presetOptions: []
        }
      };
      const option = _.find(campaign.campaignTypeData.presetOptions, presetOption => {
        return presetOption.id === optionId
      }) || {
        name: "Unknown Preset Option",
        multiplier: 0
      };
      return [option.multiplier, count];
    }
  )
}

export const selectUpdatedTicketingCampaign = createSelector(
  selectCampaignState,
  (state:fromCampaign.State) => state.updatedTicketingCampaign
)